

// ==================== FILE: components/CustomerInfoPage/components/CustomerDetailsCard.jsx ====================
import { Card, Descriptions, Typography } from "antd";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  PayCircleOutlined,
} from "@ant-design/icons";
import { cardStyle } from "../styles";

const { Text, Paragraph } = Typography;

const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("vi-VN");
};

const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleString("vi-VN");
};

export default function CustomerDetailsCard({ customer }) {
  return (
    <Card
      title={
        <>
          <UserOutlined style={{ marginRight: 8 }} />
          Thông tin khách hàng
        </>
      }
      style={cardStyle}
    >
      <Descriptions
        bordered
        column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 3 }}
        labelStyle={{ fontWeight: 600 }}
      >
        <Descriptions.Item
          label={
            <>
              <UserOutlined style={{ marginRight: 6 }} /> Họ và tên
            </>
          }
          span={1.5}
        >
          <Text strong>{customer.name}</Text>
        </Descriptions.Item>
        {/* <Descriptions.Item
          label={
            <>
              <UserOutlined style={{ marginRight: 6 }} /> Người đại diện
            </>
          }
          span={1.5}
        >
          <Text strong>{customer.represent_name}</Text>
        </Descriptions.Item> */}

        <Descriptions.Item
          label={
            <>
              <PhoneOutlined style={{ marginRight: 6 }} /> Số điện thoại
            </>
          }
          span={1.5}
        >
          <Text copyable strong>{customer.phone}</Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <MailOutlined style={{ marginRight: 6 }} /> Email
            </>
          }
        >
          <Text copyable style={{ color: "#0070D7" }}>{customer.email}</Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <CalendarOutlined style={{ marginRight: 6 }} /> Ngày sinh
            </>
          }
        >
          {formatDate(customer.dob)}
        </Descriptions.Item>

        {/* <Descriptions.Item
          label={
            <>
              <EnvironmentOutlined style={{ marginRight: 6 }} /> Số nhà
            </>
          }
          span={1}
        >
          <Text>{customer?.sonha}</Text>
        </Descriptions.Item> */}

        <Descriptions.Item
          label={
            <>
              <EnvironmentOutlined style={{ marginRight: 6 }} /> Địa chỉ
            </>
          }
          span={2}
        >
          <Paragraph style={{ margin: 0 }}>
            {customer.address || "Chưa cập nhật"}
          </Paragraph>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <EnvironmentOutlined style={{ marginRight: 6 }} /> Mã định danh
            </>
          }
        >
          {customer.identity_account || "Chưa cập nhật"}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <PayCircleOutlined style={{ marginRight: 6 }} /> Loại giảm trừ
            </>
          }
        >
          {customer.discount_type || "-"}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <PayCircleOutlined style={{ marginRight: 6 }} /> Giá trị
            </>
          }
        >
          {customer.discount_value || "-"}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <ClockCircleOutlined style={{ marginRight: 6 }} /> Ngày tạo
            </>
          }
        >
          {formatDateTime(customer.created_at)}
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <>
              <ClockCircleOutlined style={{ marginRight: 6 }} /> Cập nhật
            </>
          }
        >
          {formatDateTime(customer.updated_at)}
        </Descriptions.Item>
      </Descriptions>

    </Card>
  );
}